// Copyright (c) 2019 Deere & Company

const decimalFormats = [
    'EMPTY',
    'X',
    'Y',
];

export default decimalFormats;
